import React, { Component } from 'react';
import { Modal, Button, message, Input } from 'antd';
import { cancelCollect } from '@/request/api'
import { requestErrorLog } from "@/common/util";
import './components/styles/apply.scss';

class EditBookmark extends Component {
  state = {
    bookmarkdetail: "",
    isEdit: false
  }

  componentDidMount() {
    this.setState({
      bookmarkdetail: this.props.bookmarkdetail,
      isEdit: this.props.isEdit
    })
  }

  handleSubmitApply = () => {
    if (this.state.bookmarkdetail === "" || this.state.bookmarkdetail.trim() === '') {
      message.warning("书签不能为空")
    } else {
      const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
      const { submitType, rowData } = this.props
      let type = "";
      if (submitType === "add") { // 远程申请收藏标签
        type = "CollectionCases";
        this.collectPaint(type, rowData);
      }
      if (submitType === "edit") {  // 典型病例修改标签
        type = "PersonCasesTagUpdate";
        if (rowData.TAG_USER_UID.trim() === userInfo.USER_UID || rowData.COLLECT_TAG === '') {
          this.collectPaint(type, rowData);
        } else {
          message.warning("此用户无权限修改");
          return;
        }
      }
    }
  }

  collectPaint = (type, rowData) => { // 收藏
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: type,
      hospital_Code: userInfo.HOSPITAL_CODE,
      USER_UID: userInfo.USER_UID,
      EXAM_UID: rowData.EXAM_UID,
      COLLECT_TAG: this.state.bookmarkdetail
    }
    cancelCollect(params).then((res) => {
      if (res && res.Status === 1) {
        if (res.Result === -2) {
          message.warning("此用户无权限修改");
          return;
        }
        this.props.onRef(false);
        if (this.props.submitType === "add") {
          message.success("病例收藏成功！");
          this.props.refreshTable()
        } else {
          message.success("病例修改成功！");
          this.props.refreshTable()
        }
      } else {
        requestErrorLog(rowData.EXAM_UID, '远程申请病例收藏接口报错', 0, true)
        message.error("病例收藏失败！");
      }
    })
  }
  handleCloseApplyModal = () => {
    this.props.onRef(false);
  }

  handleInputChange = (event) => {
    this.setState({ bookmarkdetail: event.target.value });
  }

  render() {
    const { visible } = this.props
    return (
      <Modal
        className="consulationH"
        width={440}
        title={this.props.submitType === "add" ? "添加书签" : "编辑书签"}
        visible={visible}
        footer={[
          <Button key="save" type="primary" onClick={this.handleSubmitApply}>
            确定
          </Button>,
          <Button key="exit" type="primary" onClick={this.handleCloseApplyModal}>
            取消
          </Button>
        ]}
        onCancel={this.handleCloseApplyModal}  // 右上角的关闭按钮
      >
        <div style={{ padding: '10px' }}>
          <span className="conName">书签：
            <Input type="text" placeholder="请输入书签，最长不要超过25个字符" style={{ width: "320px" }} disabled={this.state.isEdit} maxLength={25}
              defaultValue={this.state.bookmarkdetail} onChange={this.handleInputChange} />
          </span>
        </div>
      </Modal>
    )
  }
}

export default EditBookmark;